import { requestApi } from './Api';

export const updateAddress = async (navigate, address, params = {}) => {
  const res = await requestApi({
    navigate,
    url: '/api/address/patch',
    params: {
      loadedAddress: address,
      ...params
    }
  });
  return res;
};
